import React, { useState } from 'react';
import { Container, Row, Col, Tabs, Tab, Card } from 'react-bootstrap';
import folder from 'assets/img/icons/folder.png';
import survey from 'assets/img/th-each-ai/survey.png';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const AdminDashboard: React.FC = () => {

    const { t } = useTranslation();

    return (
        <Card className='border border-light rounded-5' >
            <Card.Body>
                <Row>
                    <Col lg={4} xl={4} className="d-none d-lg-block">
                        <Card className="bg-soft" >
                            <Card.Body>
                                <div className='d-flex flex-column align-items-center '>
                                    <img width={100}
                                        src={folder}
                                        alt={t("AdminDashboard.learning_trends")} />

                                    <Link to="/effective-communication" className="link-100">
                                        <span className="hover-text-100 text-secondary fs-7 fw-semi-bold">
                                            {t("AdminDashboard.learning_trends")}
                                        </span>
                                    </Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={4} xl={4} className="d-none d-lg-block">
                        <Card className="bg-soft" >
                            <Card.Body>
                                <div className='d-flex flex-column align-items-center '>
                                    <img width={100}
                                        src={folder}
                                        alt={t("AdminDashboard.skill_gap_analysis")} />

                                    <Link to="/effective-communication" className="link-100">
                                        <span className="hover-text-100 text-secondary fs-7 fw-semi-bold">
                                            {t("AdminDashboard.skill_gap_analysis")}
                                        </span>
                                    </Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={4} xl={4} className="d-none d-lg-block">
                        <Card className="bg-soft" >
                            <Card.Body>
                                <div className='d-flex flex-column align-items-center '>
                                    <img width={100}
                                        src={folder}
                                        alt={t("AdminDashboard.engagement")} />

                                    <Link to="/effective-communication" className="link-100">
                                        <span className="hover-text-100 text-secondary fs-7 fw-semi-bold">
                                            {t("AdminDashboard.engagement")}
                                        </span>
                                    </Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={4} xl={4} className="d-none d-lg-block mt-3">
                        <Card className="bg-soft" >
                            <Card.Body>
                                <div className='d-flex flex-column align-items-center '>
                                    <img width={100}
                                        src={folder}
                                        alt={t("AdminDashboard.business_impact")} />

                                    <Link to="/effective-communication" className="link-100">
                                        <span className="hover-text-100 text-secondary fs-7 fw-semi-bold">
                                            {t("AdminDashboard.business_impact")}
                                        </span>
                                    </Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={4} xl={4} className="d-none d-lg-block mt-3">
                        <Card className="bg-soft" >
                            <Card.Body>
                                <div className='d-flex flex-column align-items-center '>
                                    <img width={100}
                                        src={folder}
                                        alt={t("AdminDashboard.learning_effectiveness")} />

                                    <Link to="/effective-communication" className="link-100">
                                        <span className="hover-text-100 text-secondary fs-7 fw-semi-bold">
                                            {t("AdminDashboard.learning_effectiveness")}
                                        </span>
                                    </Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>

                    <Col lg={4} xl={4} className="d-none d-lg-block mt-3">
                        <Card className="bg-soft" >
                            <Card.Body>
                                <div className='d-flex flex-column align-items-center '>
                                    <img width={100}
                                        src={survey}
                                        alt={t("AdminDashboard.lunch_survey")} />

                                    <Link to="/effective-communication" className="link-100">
                                        <span className="hover-text-100 text-secondary fs-7 fw-semi-bold">
                                            {t("AdminDashboard.lunch_survey")}
                                        </span>
                                    </Link>
                                </div>
                            </Card.Body>
                        </Card>
                    </Col>




                </Row>
            </Card.Body>
        </Card>
    );
};

export default AdminDashboard;
